import React, { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import { AuthUtils } from 'src/services/Auth/Auth.utils';
import { NotFoundView } from 'src/components/NotFoundView';
import { appRoutes } from 'src/routes/routes.types';
import { Button } from 'src/components/ui/button/button';
import { useTranslation } from 'react-i18next';
import * as Sentry from '@sentry/react';
import { signalPageReady } from 'src/utils/page-ready-signal';

const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  const isLogged = !AuthUtils.isExpired();
  const error = useRouteError() as Error;

  const redirect = isLogged
    ? {
        to: appRoutes.dashboard,
        text: t('Back to Dashboard'),
      }
    : {
        to: appRoutes.login,
        text: t('Back to Login'),
      };

  useEffect(() => {
    if (error) {
      Sentry.captureException(error);
    }
  }, [error]);

  /*
   * A terminal screen has to lift the native WebView overlay itself.
   *
   * This component is the `errorElement` for every route, so it is what renders when a lazy
   * chunk fails to load or a page throws during render. In the mobile WebView that produced a
   * white overlay held over a fully-rendered error page: the page that WOULD have signalled
   * ready never mounted, and no other component on screen signals. auth-layout already does
   * this for the session-expired screen for the same reason. No-op outside a WebView.
   */
  useEffect(() => {
    signalPageReady('/not-found');
  }, []);

  return (
    <NotFoundView>
      <div className={'tw-mt-6'}>
        <Button 
          variant={'brand'} 
          size={'lg'}
          onClick={() => window.location.href = redirect.to}
        >
          {redirect.text}
        </Button>
      </div>
    </NotFoundView>
  );
};

export { NotFoundPage };
